import * as v from 'valibot';
import { ValiError } from 'valibot';
import { TincanData, TincanDataSchema } from '../shared/types/tincan.model';
import { ScormContentClientBase, ScormClientOptions } from './scorm-content-client-base';
import { ContentClientError } from './content-client-error';
import { INVALID_RESPONSE_FORMAT_ERROR, UNEXPECTED_ERROR } from './constants';

/**
 * Implementation of TinCan content client for the Monorails (legacy) backend
 * Handles TinCan API communication with the monolithic LearnUpon backend
 */
export class TinCanContentClient extends ScormContentClientBase<TincanData> {
  /**
   * Get TinCan data for course content
   * @param opts - Options containing enrollment_id, course_id and component_id
   * @returns Validated TincanData response
   * @throws ContentClientError if validation fails or API errors occur
   */
  async getContentData(opts: ScormClientOptions): Promise<TincanData> {
    try {
      const scorm_token = await this.getToken('/enrollments/initiate_tincan_launch/0.json', opts);

      const launchUrl = this.buildLaunchUrl('/tincan_api/launch.json', scorm_token, opts);
      const response = await fetch(launchUrl);

      if (!response.ok) {
        throw new ContentClientError(`Failed to fetch TinCan data: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();

      // Validate the response against the schema
      try {
        return v.parse(TincanDataSchema, data);
      } catch (error) {
        if (error instanceof ValiError) {
          throw new ContentClientError(INVALID_RESPONSE_FORMAT_ERROR, error.issues);
        }
        throw error;
      }
    } catch (error) {
      if (error instanceof ContentClientError) {
        throw error;
      }
      throw new ContentClientError(UNEXPECTED_ERROR, error);
    }
  }
}
